<script setup>
import { onMounted } from "vue";
import { Tab } from "bootstrap";
import CotizacionEstandarCalculosKeyMetrics from "@/components/cotizacion/estandar/calculos/key-metrics";
import CotizacionEstandarCalculosLeaseParameters from "@/components/cotizacion/estandar/calculos/lease-parameters";
import CotizacionEstandarCalculosSources from "@/components/cotizacion/estandar/calculos/sources";
import CotizacionEstandarCalculosUses from "@/components/cotizacion/estandar/calculos/uses";
import CotizacionEstandarCalculosServicerIncome from "@/components/cotizacion/estandar/calculos/servicer-income";
import CotizacionEstandarCalculosLeaseTable from "@/components/cotizacion/estandar/calculos/lease-table";
import CotizacionEstandarPrevisualizacion from "@/components/cotizacion/estandar/calculos/previsualizacion";

onMounted(() => {
  // Seleccionamos todos los botones con data-bs-toggle="pill"
  const triggerTabList = document.querySelectorAll('[data-bs-toggle="pill"]');

  triggerTabList.forEach((triggerEl) => {
    const tabTrigger = new Tab(triggerEl);

    // Activar el comportamiento al hacer clic
    triggerEl.addEventListener("click", (event) => {
      event.preventDefault();
      tabTrigger.show();
    });
  });
});
</script>

<template>
  <div>
    <div class="d-flex align-items-start mt-4">
      <div
        class="nav flex-column nav-pills me-3"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <button
          class="nav-link active"
          id="v-pills-metrics-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-metrics"
          type="button"
          role="tab"
          aria-controls="v-pills-metrics"
          aria-selected="false"
        >
          Key metrics
        </button>
        <button
          class="nav-link"
          id="v-pills-parameters-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-parameters"
          type="button"
          role="tab"
          aria-controls="v-pills-parameters"
          aria-selected="true"
        >
          Lease parameters
        </button>
        <button
          class="nav-link"
          id="v-pills-sources-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-sources"
          type="button"
          role="tab"
          aria-controls="v-pills-sources"
          aria-selected="false"
        >
          Sources
        </button>
        <button
          class="nav-link"
          id="v-pills-uses-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-uses"
          type="button"
          role="tab"
          aria-controls="v-pills-messages"
          aria-selected="false"
        >
          Uses
        </button>
        <button
          class="nav-link"
          id="v-pills-settings-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-income"
          type="button"
          role="tab"
          aria-controls="v-pills-income"
          aria-selected="false"
        >
          Servicer income
        </button>
        <button
          class="nav-link"
          id="v-pills-table-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-table"
          type="button"
          role="tab"
          aria-controls="v-pills-table"
          aria-selected="false"
        >
          Lease table
        </button>
        <button
          class="nav-link"
          id="v-pills-previsualizacion-tab"
          data-bs-toggle="pill"
          data-bs-target="#v-pills-previsualizacion"
          type="button"
          role="tab"
          aria-controls="v-pills-previsualizacion"
          aria-selected="false"
        >
          Previsualizar
        </button>
      </div>
      <div class="tab-content px-3 w-100" id="v-pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="v-pills-metrics"
          role="tabpanel"
          aria-labelledby="v-pills-metrics-tab"
        >
          <CotizacionEstandarCalculosKeyMetrics />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-parameters"
          role="tabpanel"
          aria-labelledby="v-pills-parameters-tab"
        >
          <CotizacionEstandarCalculosLeaseParameters />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-sources"
          role="tabpanel"
          aria-labelledby="v-pills-sources-tab"
        >
          <CotizacionEstandarCalculosSources />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-uses"
          role="tabpanel"
          aria-labelledby="v-pills-uses-tab"
        >
          <CotizacionEstandarCalculosUses />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-income"
          role="tabpanel"
          aria-labelledby="v-pills-income-tab"
        >
          <CotizacionEstandarCalculosServicerIncome />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-table"
          role="tabpanel"
          aria-labelledby="v-pills-table-tab"
        >
          <CotizacionEstandarCalculosLeaseTable />
        </div>
        <div
          class="tab-pane fade"
          id="v-pills-previsualizacion"
          role="tabpanel"
          aria-labelledby="v-pills-previsualizacion-tab"
        >
          <CotizacionEstandarPrevisualizacion />
        </div>
      </div>
    </div>
  </div>
</template>
